import env from './env';

export const CADENCE_VERBOSE_STRING = {
  SWB: 'season (with box)',
  P3M: '3 months',
};

export const SUBSCRIPTIONS_CATEGORY = {
  dev: 45,
  prod: 438,
};

export const SALE_NAME = {
  edit: 'EDIT',
  addOn: 'ADDON',
};

export const onClickAddMore = (sale) => {
  if (sale === SALE_NAME.edit) {
    window.location = `${env.envURL}/edit?category=${SUBSCRIPTIONS_CATEGORY[env.env]}`;
  } else if (sale === SALE_NAME.addOn) {
    window.location = `${env.envURL}/add-ons?category=${SUBSCRIPTIONS_CATEGORY[env.env]}`;
  } else {
    window.location = `${env.envURL}/shop`;
  }
};
